import { render, staticRenderFns } from "./DxContentBin.vue?vue&type=template&id=a276cc5e&scoped=true&"
import script from "./DxContentBin.vue?vue&type=script&lang=js&"
export * from "./DxContentBin.vue?vue&type=script&lang=js&"
import style0 from "./DxContentBin.vue?vue&type=style&index=0&id=a276cc5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a276cc5e",
  null
  
)

export default component.exports